var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69119 14.4572C9.71652 14.5203 9.76055 14.5742 9.81737 14.6116C9.87419 14.6489 9.94109 14.668 10.0091 14.6663C10.0771 14.6646 10.1429 14.6421 10.1977 14.6018C10.2526 14.5616 10.2938 14.5055 10.3159 14.4412L14.6492 1.77454C14.6705 1.71547 14.6746 1.65154 14.6609 1.59024C14.6473 1.52894 14.6164 1.4728 14.572 1.42839C14.5276 1.38398 14.4715 1.35314 14.4102 1.33947C14.3489 1.3258 14.2849 1.32987 14.2259 1.35121L1.55919 5.68454C1.49485 5.7066 1.4388 5.74782 1.39857 5.80266C1.35833 5.85749 1.33584 5.92332 1.33409 5.99131C1.33235 6.05931 1.35145 6.1262 1.38883 6.18303C1.4262 6.23985 1.48007 6.28388 1.54319 6.30921L6.82985 8.42921C6.99698 8.49612 7.14882 8.59618 7.27623 8.72336C7.40364 8.85054 7.50398 9.0022 7.57119 9.16921L9.69119 14.4572Z",
    fill: "#FFB5B7",
    stroke: "#600002",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5697 1.4314L7.27637 8.72406",
    stroke: "#600002",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_send.8b151bf0a615d2104fe0c2ec435b208d.svg";
export { ForwardRef as ReactComponent };